import React from 'react';
import ReactDOM from 'react-dom';
import Root from './pages/Root';
import './index.css'

ReactDOM.render(
  <Root/>,
  document.getElementById('root')
);
